import { render } from "./MensalGrowth.vue?vue&type=template&id=9d9c9462"
import script from "./MensalGrowth.vue?vue&type=script&lang=js"
export * from "./MensalGrowth.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tio-patinhas/tio-patinhas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__